import { parseStored } from "./runtime-utils.js";
export function connectionIds(storage, storagePrefix) {
    const index = parseStored(storage.getItem(`${storagePrefix}:connections`));
    return index?.version === 1 && Array.isArray(index.collectionIds)
        && index.collectionIds.every((collectionId) => typeof collectionId === "string")
        ? index.collectionIds
        : [];
}
export function addConnectionId(storage, storagePrefix, collectionId) {
    writeConnectionIds(storage, storagePrefix, [...connectionIds(storage, storagePrefix), collectionId]);
}
export function removeConnectionId(storage, storagePrefix, collectionId) {
    writeConnectionIds(storage, storagePrefix, connectionIds(storage, storagePrefix).filter((id) => id !== collectionId));
}
function writeConnectionIds(storage, storagePrefix, ids) {
    storage.setItem(`${storagePrefix}:connections`, JSON.stringify({
        version: 1,
        collectionIds: [...new Set(ids)]
    }));
}
